module.exports = __webpack_public_path__ + "img/ReviewOrderCardStatus.98489e39.png";